import { useTranslations } from '../../../../lang/TranslationHooks';

import { className } from '../../../../Utils';

import checkedNew from '../../assets/checkedNew.svg'
import iconX from '../../assets/iconX.svg'

import './AccordionHeader.css';

const AccordionHeader = ({ title, SetIsOpenVideoHandler, setOpenAccordion, data, freeFunctionality, videoUrl }) => {
    let { staticTranslate } = useTranslations();

    return (
        <header
            className={className('container-header')}
            onClick={() => setOpenAccordion(prev => !prev)}
        >
            <div className={className("contaier-header-image-container")}>
                <p className={className('container-header-title')}>
                    {title}
                </p>
                {data.length > 0 &&
                    <div className={className('header-info')} >
                        {videoUrl &&
                            <p
                                onClick={(e) => {
                                    e.stopPropagation()
                                    SetIsOpenVideoHandler(true)
                                }}>
                                {staticTranslate('t_pregnancy_video_guide', true)}
                            </p>
                        }
                        <p> {staticTranslate('t_pregnancy_learn_more', true)}</p>
                    </div>
                }
            </div>
            <div
                className={className('feature-icon-container')}
            >
                {freeFunctionality
                    ? <div className={className('accordion-icon-wrapper') + ' ' + className('first-two-icons')}>
                        <img
                            src={checkedNew}
                            className={className('accordion-icon-checked')}
                            alt="checked"
                            loading='lazy'
                        />
                    </div>
                    : <div className={className('accordion-icon-wrapper')}>
                        <img
                            src={iconX}
                            className={className('accordion-icon-freeIcon')}
                            alt="free icon"
                            loading='lazy'
                        />
                    </div>
                }
                <div className={className('crown-wrapper')}>
                    <img
                        src={checkedNew}
                        className={className('accordion-icon-checked')}
                        alt="checked"
                        loading='lazy'
                    />
                </div>
            </div>
        </header>
    );
};

export default AccordionHeader;
